var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"py-4 text-light",attrs:{"align-h":"between","no-gutters":""}},[_c('b-col',[_vm._v(_vm._s(_vm.from)+" - "+_vm._s(_vm.to))]),_c('b-col',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.total)+" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }